exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html:lang(en) .swal2-container{font-family:Roboto,sans-serif}html:lang(km) .swal2-container{font-family:Chenla,sans-serif;line-height:1.8}.menu__content--select{max-height:208px!important}.expansion-panel__header{padding:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4dd22432","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/App.vue
// module id = qq14
// module chunks = 12